import Container from 'typedi';
import { Constructable } from '../types';

class Base { }

export const useViewModel = <T extends Base>(vm: Constructable<T>): T => {
  return Container.get(vm);
};